import domready from 'domready';

domready(() => {
  $(document).on('select2:open', () => {
    document.querySelector('.select2-search__field').focus();
  });
})

